// Intercom Specific Handling
const INTERCOM_APP_ID = 'ud43g8st';
export const intitializeIntercom = async (user) => {
  await new Promise((resolve) => {
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
          resolve();
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
  });

  user && !user.intercom_hash && console.log(`Need to complete User Intercom Hash Integration`);
  window.Intercom('boot', {
    api_base: process.env.REACT_APP_API_URL,
    app_id: INTERCOM_APP_ID,
    user_hash: user?.intercom_hash,
    user_id: `${user?.id}`,

    name: `${user.first_name} ${user.last_name}`,
    email: user?.email,
    company: user?.company?.name,
  });
};
